import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, QuestionAnswer, QuestionTickerType } from 'src/app/interfaces/question';
import { Profile } from 'src/app/interfaces/user';
import { QuestionImageType } from './../../../../interfaces/question';
/**
 * linear question에서 친구 결과와 비교하는 컴포넌트
 */

export interface ComparisonAnswer {
  optionId: number;
  faIcon?: string; // fontawesome icon 있는 경우는 profileImage 말고 icon으로 표시
  profile?: Profile;
  firstName?: string;
  text?: string;
  position: 'top' | 'bottom';
}

@Component({
  selector: 'question-linear-favour-comparison',
  templateUrl: './linear-question-favour-comparison.component.html',
  styleUrls: ['./linear-question-favour-comparison.component.scss'],
})
export class LinearQuestionFavourComparisonComponent implements OnInit {

  constructor() { }

  @Input() question: Question | undefined;
  @Input() disabled = false;
  @Input() checkedOption: ComparisonAnswer | undefined;
  @Input() compareOption: ComparisonAnswer | undefined;
  @Input() averageOption: ComparisonAnswer | undefined;
  @Input() isVariedCircleSize = true; // 증감 형태의 circle button일 경우
  @Input() exampleStyle: 'default' = 'default';
  @Input() otherSideSelectedColor = 'var(--blue-70)'; // 비교 옵션이 있을 경우, 비교 값과 다른 사이드를 선택 시 컬러
  @Input() imageType: QuestionImageType | undefined;
  @Input() tickerBackgroundColor: string | undefined;
  @Input() tickerSize: 'small' | 'medium' | 'large' = 'large';
  @Input() tickerType: QuestionTickerType = 'default';
  @Input() showTickerToggleIcon = false;
  @Output() answered = new EventEmitter<QuestionAnswer>();

  ngOnInit() {
  }

  onSelected(data): void {
    this.answered.emit(data);
  }
}
